// extracted by mini-css-extract-plugin
export default {"container":"footer_container__FhC7J","text":"footer_text__lMpIn","logo":"footer_logo__-PO_9","credits":"footer_credits__3lMax","partners":"footer_partners__3pPbW"};